import React, { Component, Fragment } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { concepts_payroll } from '../localdata/conceptos';
import { Col } from 'react-bootstrap';
import ExtraHourForm from './extraHoursForm';
import GeneralOneValueForm from './generalOneValueForm';
import DateValueForm from './dateValueForm';

class Example extends Component {
  empresa = sessionStorage.getItem('company');
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      gtic_code: '',
      dataDetail: {},
    }
  }

  handleShow = () => {
    this.setState({ show: true })
  }

  handleClose = () => {
    this.setState({ gtic_code: '', show: false })
  }

  infoDetailSelect = ({ value, code, total_line, quantity, init_date, final_date }) => {
    const info = {
      valor: value,
      valor_total_linea: total_line,
      codigo_movimiento: code,
      cantidad: quantity,
      periodo_inicio: init_date,
      periodo_fin: final_date,
    }
    this.setState({ dataDetail: info })
  }

  saveDetail = () => {
    // e.preventDefault()
    const returnInfo = this.props.returnInfo;
    returnInfo(this.state.dataDetail);
    this.setState({ dataDetail: {}, gtic_code: '', show: false })
  }


  render() {
    const { show } = this.state;
    const { valor_hora } = this.props;
    return (
      <Fragment>
        <Button variant="success" onClick={this.handleShow}>
          Agregar Novedad
        </Button>
        <Modal
          show={show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton={this.handleClose}>
            <Modal.Title>Agregar Detalle Nomina</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(e) => this.saveDetail(e)}>
              <Form.Group as={Col} controlId="formGridbase">
                <Form.Label>Tipo</Form.Label>
                <Form.Control
                  as="select"
                  onChange={(e) =>
                    this.setState({ gtic_code: e.target.value })
                  }
                  value={this.state.gtic_code}
                  required
                >
                  <option value="">--Seleccione--</option>
                  {
                    concepts_payroll.map((concept) => <option key={concept.code} value={concept.code} >{concept.description}</option>)
                  }
                </Form.Control>
              </Form.Group>
            </Form>
            {this.state.gtic_code === "01" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='EXTRAS DIURNAS' valor_hora={valor_hora} />}
            {this.state.gtic_code === "02" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='EXTRAS NOCTURNAS' valor_hora={valor_hora} />}
            {this.state.gtic_code === "03" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='REGULARES NOCTURNAS' valor_hora={valor_hora} />}
            {this.state.gtic_code === "04" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='EXTRAS DIURNAS DOMINICALES' valor_hora={valor_hora} />}
            {this.state.gtic_code === "05" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='REGULARES DIURNAS DOMINICALES' valor_hora={valor_hora} />}
            {this.state.gtic_code === "06" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='EXTRAS NOCTURNAS DOMINICALES' valor_hora={valor_hora} />}
            {this.state.gtic_code === "07" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='REGULARES NOCTURNAS DOMINICALES' valor_hora={valor_hora} />}
            {this.state.gtic_code === "18" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='SUELDO' valor_hora={valor_hora * 8} />}
            {this.state.gtic_code === "13" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='PRIMA' />}
            {this.state.gtic_code === "20" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='SALUD' />}
            {this.state.gtic_code === "21" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='PENSION' />}
            {this.state.gtic_code === "22" && <ExtraHourForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} name='AUXILIO DE TRANSPORTE' />}

            {(this.state.gtic_code === "12" ||
              this.state.gtic_code === "19" ||
              this.state.gtic_code === "23" ||
              this.state.gtic_code === "24" ||
              this.state.gtic_code === "25" ||
              this.state.gtic_code === "26" ||
              this.state.gtic_code === "27" ||
              this.state.gtic_code === "28" ||
              this.state.gtic_code === "29" ||
              this.state.gtic_code === "30" ||
              this.state.gtic_code === "31" ||
              this.state.gtic_code === "32" ||
              this.state.gtic_code === "33" ||
              this.state.gtic_code === "34" ||
              this.state.gtic_code === "35" ||
              this.state.gtic_code === "36" ||
              this.state.gtic_code === "37" ||
              this.state.gtic_code === "38" ||
              this.state.gtic_code === "15" ||
              this.state.gtic_code === "16" ||
              this.state.gtic_code === "17" ||
              this.state.gtic_code === "39" ||
              this.state.gtic_code === "40" ||
              this.state.gtic_code === "41" ||
              this.state.gtic_code === "42" ||
              this.state.gtic_code === "43" ||
              this.state.gtic_code === "44" ||
              this.state.gtic_code === "45" ||
              this.state.gtic_code === "46" ||
              this.state.gtic_code === "47" ||
              this.state.gtic_code === "48" ||
              this.state.gtic_code === "49" ||
              this.state.gtic_code === "50" ||
              this.state.gtic_code === "51")
              && <GeneralOneValueForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} />}

            {
              (this.state.gtic_code === "08" ||
                this.state.gtic_code === "09" ||
                this.state.gtic_code === "10" ||
                this.state.gtic_code === "11" ||
                this.state.gtic_code === "14-1" ||
                this.state.gtic_code === "14-2" ||
                this.state.gtic_code === "14-3")
              && <DateValueForm returnData={this.infoDetailSelect} concept={this.state.gtic_code} />
            }
          </Modal.Body>
          <Modal.Footer>
            <Button className='mr-2' variant="secondary" onClick={this.handleClose}>Cancelar</Button>
            <Button variant="primary" onClick={this.saveDetail}>Aceptar</Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;


// WEBPACK FOOTER //
// ./src/components/nomina/subcomponents/detailPayrollModal.jsx